import { useEffect, useState } from "react";
import paymentService from "../../services/paymentService";
import { addDataLayer } from "../../utils/utility";
import PaymentFailure from "../paymentFailure";
import { setOrderId } from "../../services/cartService";
import { cartValueEventDL } from "../../utils/dataLayerManager";
import Button from "../../components/button";
import { CartState } from "../../utils/interfaces/cart";
import { useAppSelector } from "../../hooks";
import { selectCartSelector } from "../../store/cart/selector";

interface CheckoutProps {
  termConditionCheck: boolean;
  adminData: any;
  cartData?: CartState;
}

interface SubmitCyber {
  [key: string]: string;
}

const Checkout = (props: CheckoutProps) => {
  const { termConditionCheck, adminData } = props;
  const omitFormFields = ["redirectorUrl", "invitationId"];
  const [paymentError, setPaymentError] = useState<Error | undefined>(
    undefined
  );
  const [isProcessing, setIsProcessing] = useState(false);
  const cartData = useAppSelector(selectCartSelector);
 
  const [submitCyber, setSubmitCyber] = useState<SubmitCyber>({
    redirectorUrl: "",
    appName: "",
    appPass: "",
    merchantId: "",
    accountType: "",
    transactionType: "",
    lang: "",
    clientReturnUrl: "",
    customerFirstName: "",
    customerLastName: "",
    customerEmail: "",
    customerAddress: "",
    customerAddress2: "",
    customerCity: "",
    customerPostalCode: "",
    customerState: "",
    customerCountry: "",
    clientSessionData: "anyValue",
    invitationId: "",
    orderId: "",
    totalAmount: "",
  });

  useEffect(() => {
    paymentService.getPaymentConfig().then((res) => {
      setSubmitCyber((prevState) => ({
        ...prevState,
        redirectorUrl: res.payment_redirector_url,
        appName: res.payment_app_name,
        appPass: res.payment_app_pass,
        merchantId: res.payment_merchant_id,
        accountType: res.payment_account_type,
        transactionType: res.payment_transaction_type,
        lang: res.payment_lang,
        clientReturnUrl: res.payment_validation_url,
        orderId: "",
        clientSessionData: "anyValue",
        invitationId: "",
      }));
    });
    if (window.location.href.includes("/response/failed")) {
      setPaymentError(new Error("error in payment"));
    }
  }, []);

  useEffect(() => {
    setSubmitCyber((prevState) => ({
      ...prevState,
      customerFirstName: adminData.firstname,
      customerLastName: adminData.lastname,
      customerEmail: adminData.email,
      customerAddress: adminData?.street ? adminData?.street[0] : "",
      customerAddress2: adminData?.street ? adminData?.street[1] : "",
      customerCity: adminData.city,
      customerPostalCode: adminData.postcode,
      customerState: adminData?.region ? adminData.region.code : "",
      customerCountry: adminData.country ? adminData.country.code : "",
      totalAmount: adminData.grandTotal ? adminData.grandTotal.value.toFixed(2) : 0.00,
    }));
  }, [adminData])

  const handleCheckout = () => {
    setIsProcessing(true);
    paymentService
      .setPaymentMethod(adminData.cartId)
      .then((res) => {
        if (res) {
          paymentService
            .placeOrder(adminData.cartId)
            .then((resp) => {
              if (resp) {
                setOrderId(resp.order.order_number);
                setSubmitCyber((prevState) => ({
                  ...prevState,
                  orderId: resp.order.order_number,
                  clientSessionData: resp.order.order_number,
                }));
                addDataLayer(cartValueEventDL("begin_checkout", cartData), "begin_checkout");                 
              }
            })
            .catch((error) => {
              setIsProcessing(false);
              setPaymentError(error);
            });
        }
      })
      .catch((error) => {
        setIsProcessing(false);
        setPaymentError(error);
      });
  };

  useEffect(() => {
    if (submitCyber.orderId === "" || submitCyber.clientSessionData === "anyValue")
      return;
    setIsProcessing(false);
    const form = document?.getElementById("checkout-form") as HTMLFormElement;
    const orderId = document.getElementById("orderId") as HTMLInputElement;
    const clientSessionData = document.getElementById("clientSessionData") as HTMLInputElement;
    if (orderId.value === "" || clientSessionData.value === "anyValue") {
      orderId.value = submitCyber.orderId;
      clientSessionData.value = submitCyber.clientSessionData;
    }
    form?.submit();
  }, [submitCyber.orderId, submitCyber.clientSessionData]);

  return (
    <form
      id="checkout-form"
      action={submitCyber.redirectorUrl}
      method="POST"
      className="w-full"
    >
      {Object.keys(submitCyber).map(
        (key) =>
          !omitFormFields.includes(key) && (
            <input
              id={key}
              key={`checkout-hidden-form-${key}`}
              type="hidden"
              name={key}
              value={submitCyber[key]}
              onChange={(e) =>
                setSubmitCyber((prevState) => ({
                  ...prevState,
                  [key]: e.target.value,
                }))
              }
            />
          )
      )}
      <Button
        label="Checkout"
        customClass="submit-btn !px-8 py-2 text-white font-bold mr-4 w-full"
        loader={isProcessing}
        loadingText="Processing"
        submit={handleCheckout}
        disabled={!termConditionCheck}
      />
      {paymentError && (
        <PaymentFailure
          error={paymentError}
          setError={setPaymentError}
          tryPaymentAgain={handleCheckout}
          loading={isProcessing}
        />
      )}
    </form>
  );
};

export default Checkout;
